import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography, Stack, Paper } from '@mui/material'
import T from 'prop-types'

export default function CarsToBuyPageTitleRightColumn({
  countDown,
  stateKey = 'publication',
}) {
  const { t } = useTranslation()
  const { days, hours, minutes, expired } = countDown
  return (
    <Stack direction="row" alignItems="center">
      <Typography variant="body2" color={'primary'} sx={{ paddingRight: 2 }}>
        <strong>
          {t(`sessions.state.${stateKey}.${!expired ? 'open' : 'closed'}`)}
        </strong>
      </Typography>
      <Typography variant="body2" color="textPrimary">
        {t(`carsToBuy.timer.head`)}
      </Typography>
      <Paper sx={{ p: 0.5 }}>{`${days}`.padStart(2, 0)}</Paper>
      <Box pr={0.5} />
      <Typography variant="body2" color="textPrimary">
        {t(`carsToBuy.timer.days`)}
      </Typography>
      <Box pr={0.5} />
      <Paper sx={{ p: 0.5 }}>{`${hours}`.padStart(2, 0)}</Paper>
      <Box pr={0.5} />
      <Typography variant="body2" color="textPrimary">
        {t(`carsToBuy.timer.hours`)}
      </Typography>
      <Box pr={0.5} />
      <Paper sx={{ p: 0.5 }}>{`${minutes}`.padStart(2, 0)}</Paper>
      <Box pr={0.5} />
      <Typography variant="body2" color="textPrimary">
        {t(`carsToBuy.timer.minutes`)}
      </Typography>
    </Stack>
  )
}

CarsToBuyPageTitleRightColumn.propTypes = {
  countDown: T.object,
  stateKey: T.string,
}
